import React from 'react';
const stats = [{
  value: '+500',
  label: 'PE Teachers',
  color: 'text-[#FF6B00]'
}, {
  value: '6+5',
  label: 'Volumes + Bonuses',
  color: 'text-[#FF6B00]'
}, {
  value: '4.9/5',
  label: 'rating ⭐',
  color: 'text-[#FF6B00]'
}, {
  value: '🌍',
  label: 'Worldwide',
  color: 'text-[#0A0A0A]'
}];
const testimonials = [{
  quote: 'I planned my entire school year in a single evening. Now every PE lesson has a clear objective and my students actually look forward to class.',
  name: 'James R.',
  role: 'Primary PE Teacher'
}, {
  quote: 'My students are improving so much faster now that they finally follow a logical skill progression. This changed everything.',
  name: 'Coach Mike',
  role: 'Middle School PE Teacher'
}, {
  quote: 'I no longer spend hours on YouTube hunting for activities. I open P.E. READY 360 and it is all there. Everything. Ready to go.',
  name: 'Sarah L.',
  role: 'High School PE Teacher'
}];
export function SocialProofBar() {
  return <section className="w-full bg-white py-12 px-4 border-b border-[#E5E5EA]" data-id="element-192">
      <div className="max-w-5xl mx-auto" data-id="element-193">
        <div className="flex flex-wrap items-center justify-around gap-6 bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl px-6 py-6 mb-10 shadow-sm" data-id="element-194">
          {stats.map((s, i) => <div key={i} className="text-center min-w-[100px]" data-id="element-195">
              <div className={`text-3xl sm:text-4xl font-black ${s.color} tracking-tight`} data-id="element-196">
                {s.value}
              </div>
              <div className="text-[#5A5A66] text-xs sm:text-sm font-bold mt-1 uppercase tracking-wider" data-id="element-197">
                {s.label}
              </div>
            </div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-198">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-[#E5E5EA] rounded-2xl p-6 shadow-sm flex flex-col" data-id="element-199">
              <div className="text-[#FFD700] text-lg mb-3" data-id="element-200">⭐⭐⭐⭐⭐</div>
              <p className="text-[#0A0A0A] text-sm sm:text-base font-medium italic flex-1 mb-4 leading-relaxed" data-id="element-201">
                "{t.quote}"
              </p>
              <div data-id="element-202">
                <div className="font-black text-[#0A0A0A] text-sm" data-id="element-203">
                  {t.name}
                </div>
                <div className="text-[#5A5A66] text-xs font-semibold" data-id="element-204">
                  {t.role}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}